import fetch from 'isomorphic-fetch';
import BaseApi from '../../../../shared/javascripts/api/BaseApi'

class UserApi extends BaseApi {
  static fetchUser(id) {
    return fetch(this.buildRequest(`/v1/users/${id}.json`))
  }
}

export default UserApi



// WEBPACK FOOTER //
// ./src/reports/general/javascripts/api/UserApi.js